import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalService } from 'app/shared/services/modal.service';
import { ReleaseNotesDialogService } from 'app/shared/services/release-notes-dialog.service';
import { GlobalStore } from 'app/shared/store/global.store';
import { DialogService } from 'primeng/dynamicdialog';
import { NavbarComponent } from './navbar/navbar.component';

@Component({
  selector: 'inpla-main',
  imports: [RouterOutlet, NavbarComponent],
  providers: [ReleaseNotesDialogService, DialogService, ModalService],
  templateUrl: './main-container.component.html',
  styleUrl: './main-container.component.scss',
})
export class MainComponent implements OnInit, OnDestroy {
  private readonly globalStore = inject(GlobalStore);
  private readonly releaseNotesDialogService: ReleaseNotesDialogService = inject(ReleaseNotesDialogService);

  ngOnInit(): void {
    this.globalStore.setTheme(localStorage.getItem('indago-theme'));
  }

  ngOnDestroy() {
    this.releaseNotesDialogService.destroyDialog();
  }
}
